import { IConnectOauth, IProvider } from '@/models/provider';

export class MerchantState {
  constructor(
    public initialized = false,
    public providers: IProvider[] = [],
    public providersCountry: IProvider[] = [],
    public connectedProviders: IConnectOauth[] = [],
    public providersToUpdate: IConnectOauth[] = []
  ) {}
}
